import NewFeedCandidateLayout from '../../components/newFeedCandidates/NewFeedCandidateLayout'
import React from 'react'

const InAppLink = () => {
    const form = {
        actionType: 'IN_APP_LINK',
        url: true,
        quiz: false,
        calendar: false,
    }
    return <NewFeedCandidateLayout form={form} />
}

export default InAppLink
